<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 



        <md-card class="md-elevation-0 m-5">

          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Información del Mancomuno
          </md-card-header>     
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>  
          </md-card-content>
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('porcentaje')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Porcentaje de Cuotas del Mancomuno *
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Llenar el porcentaje de la inversión que corresponde al mancomuno que está llenando este formulario. Este porcentaje será utilizado en la retención del impuesto a la renta al momento del rescate. EN CASO DE SOCIEDAD CONYUGAL, las opciones son solo: 50%-50% o 100%-0%.              
            </p>           
            <div>            
              <!--               
              <md-field :class="getValidationClass('porcentaje')">
                <md-input type="text" id="porcentaje" name="porcentaje" placeholder="Su respuesta" v-model="form.porcentaje"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.porcentaje.required">Esta respuesta es obligatoria.</span>
              </md-field>
              -->

              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <ejs-numerictextbox :min="0" :value="val1" :max="100" format="n" :step="1" @change="ooo"></ejs-numerictextbox>
                  <div class="md-layout-item"><b>Mancomuno</b></div>
                </div>
                <div class="md-layout-item">
                  <ejs-numerictextbox  :min="0" :value="val2" :max="100" format="n" :step="1" @change="uuu"></ejs-numerictextbox>
                  <div class="md-layout-item"><b>Titular y resto Mancomunos</b></div>
                </div>
              </div>

              <div class="radioform" :class="getValidationClass('porcentaje')">
                <span class="md-error" v-if="!$v.form.porcentaje.required">El porcentaje de cuotas debe sumar al 100%</span>
              </div>                  
              

            </div>
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('paterno')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido Paterno del Mancomuno *
          </md-card-header>
          <md-card-content>

            <div>            
              <md-field :class="getValidationClass('paterno')">
                <md-input type="text" id="paterno" name="paterno" placeholder="Su respuesta" v-model="form.paterno" v-on:keypress="isLetter($event, 0)"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.paterno.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.paterno.alpha">Formato inválido</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('materno')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido Materno del Mancomuno *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('materno')">
                <md-input type="text" id="materno" name="materno" placeholder="Su respuesta" v-model="form.materno" v-on:keypress="isLetter($event, 0)"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.materno.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.materno.alpha">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombres')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Nombre(s) del Mancomuno *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('nombres')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.nombres" v-on:keypress="isLetter($event, 0)"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nombres.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nombres.alpha">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                                       

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Documento de identidad *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.docIdentidad" value="DNI">DNI</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="CE">Carné Extranjería</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="PAS">Pasaporte</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidad')">
                <span class="md-error" v-if="!$v.form.docIdentidad.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de documento de identidad *
          </md-card-header>
          <md-card-content>

            <div>
              <md-field :class="getValidationClass('nroIdentidad')">
                <md-input type="text" id="nroIdentidad" name="nroIdentidad" placeholder="Su respuesta" v-model="form.nroIdentidad" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nroIdentidad.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidad.valDoc">Formato inválido</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidad.minLength">Formato inválido</span>                  
              </md-field>

            </div>
          </md-card-content> 
        </md-card>

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('fechaNac')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Fecha de Nacimiento *
          </md-card-header>
          <md-card-content>

            <div>
              <md-datepicker v-model="form.fechaNac"  autocomplete="off"/>
            </div>       

            <div class="radioform" :class="getValidationClass('fechaNac')">
              <span class="md-error" v-if="!$v.form.fechaNac.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-else-if="!$v.form.fechaNac.isDate">Formato inválido(dd/mm/yyyy).</span>
            </div>

          </md-card-content> 
        </md-card>        

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('sexo')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Género *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.sexo" value="Femenino">Femenino</md-checkbox>
                <md-checkbox v-model="form.sexo" value="Masculino">Masculino</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidad')">
                <span class="md-error" v-if="!$v.form.sexo.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card> 

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('direccion')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Dirección (incluir el mayor detalle posible) *
          </md-card-header>
          <md-card-content>
            <p align="justify" class="cursiva">
              En pleno ejercicio de mis derechos ciudadanos y de conformidad con lo dispuesto en la Ley N° 28882 de Simplificación de la Certificación Domiciliaria, DECLARO BAJO JURAMENTO que mi domicilio actual se encuentra ubicado en:              
            </p>
            <div>            
              <md-field :class="getValidationClass('direccion')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.direccion"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.direccion.required">Esta respuesta es obligatoria.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>             

        <md-card class="md-elevation-0 m-5" :class="getValidationClass2('nacionalidad')">
          <md-card-header  class="md-layout md-alignment-center-left justify">
            Nacionalidad *
          </md-card-header>
          <md-card-content>           
              <div class="md-layout-item md-layout">
                <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-15 md-small-size-25 md-xsmall-size-30">
                  <md-checkbox v-model="form.nacionalidad" value="Peruana">Peruana</md-checkbox>
                  <md-checkbox v-model="form.nacionalidad" value="Otros" @change="ChangeOption">Otros</md-checkbox>
                </div>
                <div class="md-layout md-layout-item md-gutter md-alignment-bottom-left">
                    <div class="md-layout-item">

                      <md-field class="md-field-aux" :class="getValidationClass('nacionalidaddes')">
                        <md-input type="text" name="otros" placeholder="Su respuesta" v-model="form.nacionalidaddes" v-on:keypress="isLetter($event, 0)" autocomplete="off" :disabled="otros0" />
                        <span class="md-error" v-if="!$v.form.nacionalidaddes.required">Su respuesta es obligatoria.</span>
                        <span class="md-error" v-else-if="!$v.form.nacionalidaddes.alpha">Formato inválido</span>
                      </md-field>   

                    </div>
  
                </div>
              </div>  

              <div class="radioform" :class="getValidationClass('nacionalidad')">
                <span class="md-error" v-if="!$v.form.nacionalidad.required">Esta respuesta es obligatoria.</span>
              </div>                                    

          </md-card-content>
        </md-card>           

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('celular')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de celular *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('celular')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.celular"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.celular.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.celular.alpha2">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card> 

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('email')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Correo electrónico *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('email')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.email"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.email.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.email.email">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                     

        <md-card class="md-elevation-0 m-5" :class="getValidationClass2('domicilioFuera')">
          <md-card-header  class="md-layout md-alignment-center-left justify">
            ¿Tiene registrado algún domicilio fuera del Perú? *
          </md-card-header>
          <md-card-content>
              <p align="justify">
                En caso de tener algún domicilio fuera del Perú, indicar el país en “Otros”.
              </p>             
              <div class="md-layout-item md-layout">
                <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-15 md-small-size-25 md-xsmall-size-30">
                  <md-checkbox v-model="form.domicilioFuera" value="No" @change="ChangeOptionD">No</md-checkbox>
                  <md-checkbox v-model="form.domicilioFuera" :value="0" @change="ChangeOptionD">Otros</md-checkbox>
                </div>
                <div class="md-layout md-layout-item md-gutter md-alignment-bottom-left">
                    <div class="md-layout-item">

                      <md-field class="md-field-aux" :class="getValidationClass('domicilioFuerades')">
                        <md-input type="text" name="otros" placeholder="Su respuesta" v-model="form.domicilioFuerades" autocomplete="off" :disabled="otros1" />
                        <span class="md-error" v-if="!$v.form.domicilioFuerades.required">Su respuesta es obligatoria.</span>
                        <span class="md-error" v-else-if="!$v.form.domicilioFuerades.alpha">Formato inválido.</span>
                      </md-field>   

                    </div>
  
                </div>
              </div>  

              <div class="radioform" :class="getValidationClass('domicilioFuera')">
                <span class="md-error" v-if="!$v.form.domicilioFuera.required">Esta respuesta es obligatoria.</span>
              </div>                                    

          </md-card-content>
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('filedni')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Aquí adjuntar ambas caras de su DNI. *
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Puede adjuntar un documento PDF o imágenes de su DNI.
            </p>
            <div v-if="data.allowUpload">
              <md-field>
                <md-file v-model="form.filedni" @md-change="uploadFile" accept="image/*, .pdf" />
              </md-field>

              <div class="md-layout" v-show="!showPorcentaje">
                <div class="md-layout-item" style="margin-left:36px">
                  <md-progress-bar class="md-accent" md-mode="determinate" :md-value="uploadPercentage" :md-buffer="buffer"></md-progress-bar>
                </div>  
              </div>
              <div class="md-layout" v-show="showPorcentajeSuccess">
                <div class="md-layout-item" style="position:relative">
                  <div style="position:absolute; right:0">
                    <md-icon class="md-primary">check_circle</md-icon>
                  </div>
                  
                </div>
              </div>

            </div>

            <div class="cardDownload">
              <md-card class="cardDetail md-elevation-0" v-show="data.showFile" >
                <md-card-media>
                  <a href="javascript:;" @click="downloadFileRoot"><img :src="file" width="30" height="30"></a>
                </md-card-media>
              </md-card>

            </div>   

            <div class="radioform" :class="getValidationClass('filedni')">
              <span class="md-error" v-if="!$v.form.filedni.required">Esta respuesta es obligatoria.</span>
            </div>            
          
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5">

          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Test de presencia substancial en EEUU
          </md-card-header>     

        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('permanecio183eua')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Ha permanecido al menos 183 días en EEUU el año pasado. * 
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.permanecio183eua" value="Si">Sí</md-checkbox>
                <md-checkbox v-model="form.permanecio183eua" value="No">No</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('permanecio183eua')">
                <span class="md-error" v-if="!$v.form.permanecio183eua.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('permanecio122en3meses')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Ha permanecido en promedio 122 días al año en EE.UU. durante los últimos 3 años. * 
          </md-card-header>
          <md-card-content>                   
              <div>
                <md-checkbox v-model="form.permanecio122en3meses" value="Si">Sí</md-checkbox>
                <md-checkbox v-model="form.permanecio122en3meses" value="No">No</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('permanecio122en3meses')">
                <span class="md-error" v-if="!$v.form.permanecio122en3meses.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card> 

        <md-card class="md-elevation-0 m-5" :class="getValidationClass2('residenciapermanente')">
          <md-card-header  class="md-layout md-alignment-center-left justify">
            ¿Reside usted en Perú?
          </md-card-header>
          <md-card-content>
              <p align="justify">
                En caso su respuesta sea No, por favor indique el país en &quot;Otros&quot;.
              </p>             
              <div class="md-layout-item md-layout">
                <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-15 md-small-size-25 md-xsmall-size-30">
                  <md-checkbox v-model="form.residenciapermanente" value="Si" @change="ChangeOptionR">Sí</md-checkbox>
                  <md-checkbox v-model="form.residenciapermanente" :value="0" @change="ChangeOptionR">Otros</md-checkbox>
                </div>
                <div class="md-layout md-layout-item md-gutter md-alignment-bottom-left md-xsmall-size-100" style="padding-bottom:10px">
                    <div class="md-layout-item" >
                        <ejs-dropdownlist ref="pa"  v-model="form.residenciapermanentedes" 
                        :enabled="!otros2" placeholder='Seleccione' 
                        popupHeight='250px' sortOrder="Ascending" 
                        :allowFiltering='allowFiltering' 
                        :filtering='filtering' 
                        :dataSource='pais' 
                        :fields='fields'/>

                    </div>
  
                </div>
              </div>  

              <div class="radioform" :class="getValidationClass('residenciapermanentedes')">
                <span class="md-error" v-if="!$v.form.residenciapermanentedes.required">Su respuesta es obligatoria.</span>
              </div>
              <div class="radioform" :class="getValidationClass('residenciapermanente')">
                <span class="md-error" v-if="!$v.form.residenciapermanente.required">Esta respuesta es obligatoria.</span>
              </div>                                    

          </md-card-content>
        </md-card>                    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('rpteLegal')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            ¿En los trámites con Faro Capital usará un representante legal? * 
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.rpteLegal" value="Si" :disabled="isDisabled">Sí</md-checkbox>
                <md-checkbox v-model="form.rpteLegal" value="No" :disabled="isDisabled">No</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('rpteLegal')">
                <span class="md-error" v-if="!$v.form.rpteLegal.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>                              

        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha, isDate, alpha1, alpha2, alpha3, email, valDoc } from '../variables'
import {
  required,
  requiredIf,
  minLength
} from 'vuelidate/lib/validators'

import { Query } from "@syncfusion/ej2-data";

export default {
  mixins: [validationMixin],
  name: 'Item01',
  props:["pais", "data", "isDisabled"],
  data: () => ({
    form:{
    },
    val1:0,val2:0,
    query : new Query().select(['nacionalidad', 'idPais']).take(7),
    fields : { text: 'nacionalidad', value: 'nacionalidad' },
    allowFiltering: true,
    uploadPercentage: 0,
    showUploadPercentage:false    
  }),
  mounted: function(){
    this.form = this.$store.state.item.item01
    console.log(this.form)

    this.unjoinPorcentaje(this.form.porcentaje)
    if(this.form.fechaNac != null){
      this.form.fechaNac = new Date(this.form.fechaNac)
    }

    //this.$store.dispatch("back", false);
  },
  validations(){
    var that = this
    var validate = {
      form: {      
        porcentaje: {
          required: requiredIf(function(){
            var final = that.val1 + that.val2
            return (final < 100)
          })
        },
        paterno: {required, alpha},
        materno: {required, alpha},
        nombres: {required, alpha},
        docIdentidad: {required,},
        nroIdentidad: {required, valDoc, minLength: minLength(3)},
        fechaNac: {
          required,
          isDate (value) {
            return isDate(value)
          },          
        },
        sexo: {required,},
        direccion: {required,},
        nacionalidad: {required,},
        nacionalidaddes: {
          required: requiredIf(function(form,){
            return this.findArray(form.nacionalidad)
          }),
          alpha
        },
        celular: {required, alpha2},
        email: {required, email},
        domicilioFuera: {required,},
        domicilioFuerades: {
          required: requiredIf(function(form,){
            return (form.domicilioFuera == "0")
          }),
          alpha1        
        },
        filedni: {required,},
        permanecio183eua: {required,},
        permanecio122en3meses: {required,},
        residenciapermanente: {required,},
        residenciapermanentedes: {
          required: requiredIf(function(form,){
            return (form.residenciapermanente == "0")
          }),
        },
        rpteLegal: {required,},
      }        
    }
    return validate;
  },
  methods: {
    downloadFileRoot(){
      this.$emit('downloadFile', {item: this.$options.name, campo:"filedni"})
    },    
    isLetter(e, i) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      let validate;
      switch (i) {
        case 0:
          validate = alpha
          break;
        case 1:
          validate = alpha1
          break;          
        case 2:
          validate = alpha2
          break;
        case 3:
          validate = alpha3
          break;                    
      }

      if(validate(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },    
    ooo(e){
      this.val2 = 100 - e.value
      this.joinPorcentaje()
    },
    uuu(e){
      this.val1 = 100 - e.value
      this.joinPorcentaje()
    },
    joinPorcentaje(){
      var str = ""
      this.form.porcentaje = str.concat(this.val1, ",", this.val2)
    },
    unjoinPorcentaje(val){
      try{
        var str = val.split(",")
        this.val1 = parseInt(str[0])
        this.val2 = parseInt(str[1])
      }
      catch(e){
        this.val1=0
        this.val2=0
      }
    },
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item01
    },  
    uploadFile(e){
      var data = new FormData();
      var that = this;
      var i = 0;
      Array.from(e).forEach(file => { 
        var name = ["File.", that.data.name,".", that.$route.params.id.toString(), ".", that.$options.name, ".", i, ".", file.name.split('.').pop()].join('')
        that.form.filedniup = name;
        data.append('files', file, name);
        i++;
      }); 

      /*
      this.$store.dispatch("saveImgFormulario", data)
      .then((response)=> {console.log(response)})
      .catch((e)=> { console.log(e) });
      */
     
      var config = {
        method: 'post',
        url: 'https://'+this.$store.state.url+':5001/api/Util/Upload',
        headers: {
                'Content-Type': 'multipart/form-data'
        },
        data : data,
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          that.uploadPercentage = percentCompleted
        }
      }     

      this.$axios(config)
      .then(function (response) {
        console.log(response)
      })
      .catch(function (e) {
          console.log(e.message)
      })     
         
    },      
    ChangeOption(item){
      var that = this;
      item.find(x => {
        if(x != "Otros"){
          that.form.nacionalidaddes = null
        }
      });
    },
    ChangeOptionD(item){      
      if(item != "0"){
        this.form.domicilioFuerades = null
      }
    },
    ChangeOptionR(){
      this.$refs.pa.ej2Instances.value = null;
      this.$refs.pa.dataBind();
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0"
        if(this.form.rpteLegal == "Si"){
          index = "2"
        }else{
          index = "3"
        }

        this.$emit('setSaveForm', {id:"01", form: this.form, index: index});
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    },
    filtering: function(e) {
      var searchData = this.pais
      console.log(searchData)
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("nacionalidad", "startswith", e.text, true) : query;
      //pass the filter data source, filter query to updateData method.
      console.log(query)
      //e.updateData(searchData, query);
    },
    
    findArray(arr){

      try {
        return (arr.find(x => x == "Otros") == "Otros")
      } catch (error) {
        return true;
      }

    }         
     
  },
  computed: {
    file:function(){
      try{
        var f = this.form.filedni
        var file = f.split(".")
        var ext = file[file.length -1];
        var images = require.context('../assets/', false, /\.png$/)
        return images('./' + ext + ".png")
        }
      catch(e){
        console.log(e)
        return null
      }
    },
    otros0: function () {
      return !this.findArray(this.form.nacionalidad)
    },
    otros1: function () {
      if(this.form.domicilioFuera == "0"){
        return false;
      }
      return true;
    },
    otros2: function () {
      if(this.form.residenciapermanente == "0"){
        return false;
      }
      return true;
    },
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    showPorcentaje:function(){
      console.log("cp")
      return (this.uploadPercentage == 0 || this.uploadPercentage == 100)
    },
    showPorcentajeSuccess:function(){
      return (this.uploadPercentage == 100)
    }  

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
